import React from 'react';

/*
import {
  _hm,
  _hmDTM,
  _ht,
  cr,
  gs,
  ls,
  useNgnz,
} from 'lib';
*/
import * as cr from './_cr';
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useNgnz } from "./_csNgn";
import { useLdrz } from "./_csLdr";
import * as _ht from './_ht';
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';

import * as icm from './icm';
import * as icv from './icv';

import * as icvBaseS10Rz from './icvBaseS10Rz';

import * as icvI1zS10To from './icvI1zS10To';
import * as icvI1zS11Co1 from './icvI1zS11Co1';
import * as icvI1zS11Co2 from './icvI1zS11Co2';
import * as icvI1zS11Co3 from './icvI1zS11Co3';
import * as icvI1zS11Co4 from './icvI1zS11Co4';
import * as icvI1zS12Co from './icvI1zS12Co';
import * as icvI1zS13Co from './icvI1zS13Co';

import * as icvI1z___Mz from './icvI1z___Mz';
import * as icvI1z___Ti from './icvI1z___Ti';

//let $i18r_fst = -1;

const $pagez = {} as _ht.dz;

export const N = (pz: _ht.dz) => {

  const _gUserz = gs.useUserz();
  const _gLdrz = useLdrz();

  const _sNgnz = useNgnz();

  const _sPz = ls.usePz({
    ctt: 'r', // reserve
    dffz: icm.grtDffz({
      mode: 'r',
      role: 's',
    }),
    steps: [0],
    i18r_fst: -1,
  });

  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst,
    atrAsync: async () => {

      _gLdrz.show();

      await icm.ilzPagezAsync(_gUserz.crt._31rz._fst, $pagez, {
        sttDate: _hmDTM.getTdy(), // 利用日（自）
        endDate: _hmDTM.addDay(_hmDTM.getTdy(), 7), // 利用日（至）
      });

      _sNgnz.getPmrzAsync()
      .then(async (_dz: _ht.dz) => {

        if (_dz?.f) {

          const _i1zr_fst = _hm.cvtNbr('d', _dz.f, icv.srtz.nbrz3);
          const _i1zz = await icvI1z___Mz.loadI1zrDzAsync({
            i1zr_fst: Number(_i1zr_fst),
          });
          const _steps = 
            _i1zz.i1zrz.i1zrs1100i == 70 ?
              [2]
            : [3];
          _gLdrz.hide();
          $pagez.bLoad = false;
          _sPz.set({
            ctt: 'r',
            phs: 'dpy',
            steps: _steps,
            i1zr_fst: _i1zr_fst,
          })
        }
        else {
          _gLdrz.hide();
          $pagez.bLoad = false;
          _sPz.udtAll();
        }
      })
    },
  });

  return (
    cr.c(icvBaseS10Rz.N, {
      key: -10,
      sPz: _sPz,
      cz: {
        pageName: 
          _sPz.crt.steps[0] == 0 ?
            '予約一覧'
          : _sPz.crt.steps[0] == 1 ?
            '部屋・日時の選択'
          : _sPz.crt.steps[0] == 2 ?
            '団体の選択'
          : _sPz.crt.steps[0] == 3 ?
            '予約詳細確認・変更・キャンセル・削除'
          : _sPz.crt.steps[0] == 4 ?
            '利用申請書の印刷'
          : _sPz.crt.steps[0] == 10 ?
            '月内予約一括登録'
          : _sPz.crt.steps[0] == 11 ?
            '定期予約一括登録'
          : '',
      },
      oClds: [

        _sPz.crt.steps[0] == 0 ?
        cr.c(icvI1zS10To.N, {
          key: -10,
          sPz: _sPz,
          pagez: $pagez,
        })
        : null,

        _sPz.crt.steps[0] == 1 ?
        cr.c(icvI1zS11Co1.N, {
          key: -20,
          sPz: _sPz,
          pagez: $pagez,
        })
        : null,

        _sPz.crt.steps[0] == 2 ?
        cr.c(icvI1zS11Co2.N, {
          key: -30,
          sPz: _sPz,
          pagez: $pagez,
        })
        : null,

        _sPz.crt.steps[0] == 3 ?
        cr.c(icvI1zS11Co3.N, {
          key: -30,
          sPz: _sPz,
          pagez: $pagez,
        })
        : null,

        _sPz.crt.steps[0] == 4 ?
        cr.c(icvI1zS11Co4.N, {
          key: -40,
          sPz: _sPz,
          pagez: $pagez,
        })
        : null,

        _sPz.crt.steps[0] == 10 ?
        cr.c(icvI1zS12Co.N, {
          key: -50,
          sPz: _sPz,
          pagez: $pagez,
        })
        : null,

        _sPz.crt.steps[0] == 11 ?
        cr.c(icvI1zS13Co.N, {
          key: -60,
          sPz: _sPz,
          pagez: $pagez,
        })
        : null,

      ]
    })
  );
};
